import { render } from "./RichIcon.vue?vue&type=template&id=07e13a72"
import script from "./RichIcon.vue?vue&type=script&lang=js"
export * from "./RichIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__